export default {
  setAuthenticated(state, value) {
    state.authenticated = value;
  },
};
